import Error from "next/error";
import theme from "../../styles/theme";
import {FormattedDate} from "react-intl";
import markdownToHtml from "@/lib/markdownToHtml";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {NewsTeaser} from "@/components/news/NewsTeaser";
import {grey} from "@mui/material/colors";
import useSWR from "swr";
import { ContentContainer } from "@/components/ContentContainer";
import { futuraNextCondensedExtraBold } from "@/styles/fonts";
import {StrapiImageAsset} from "@/components/StrapiImageAsset";
import React from "react";
const { useRouter } = require("next/router");

const fetcher = (url) =>
  fetch(url).then(async (res) => {
    let response = await res.json();
    if (response?.length === 1) {
      response[0].html = await markdownToHtml(response[0].content);
    }
    return response;
  });

const News = () => {
  const router = useRouter();
  const { slug } = router.query;
  const { data: articles, error } = useSWR(
    `${
      process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"
    }/articles?slug=${slug}&_limit=1`,
    fetcher
  );

  if (error || articles?.error) {
    return <div>Cant load news</div>;
  }

  if (!articles) {
    return <div>Loading ...</div>;
  }

  if (articles.length === 0) {
    return <Error statusCode={404} />
  }

  if (articles.length === 1) {
    return (
      <ContentContainer headline="News">
        <Grid container justifyContent="center">
          <Grid item xs={10}>
            {/* BEGIN SINGLE NEWS */}
            <Grid
              container
              sx={{
                [theme.breakpoints.up("sm")]: {
                  float: "left",
                  width: "35%",
                },
                mr: 2,
                mb: 2,
              }}
            >
              <Typography
                variant="h6"
                color="common.black"
                sx={{
                  fontFamily: futuraNextCondensedExtraBold.style.fontFamily,
                  mb: 1,
                  [theme.breakpoints.up("sm")]: {mb: 0},
                  display: {xs: "block", md: "none"},
                }}
              >
                {articles[0].title}
              </Typography>
              <Grid item xs={12} sx={{
                  position: "relative",
                  aspectRatio: "16/9",
              }}>
                  <StrapiImageAsset
                      strapiImageObject={articles[0]?.image}
                      layout="fill"
                      width={400}
                      height={225}
                  />
              </Grid>
            </Grid>
            <Typography
              variant="h6"
              color="common.black"
              sx={{
                fontFamily: futuraNextCondensedExtraBold.style.fontFamily,
                mb: 1,
                position: "relative",
                zIndex: "100",
                [theme.breakpoints.up("sm")]: {mb: 0},
                display: {xs: "none", md: "block"},
              }}
            >
              {articles[0].title}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                mt: 0.5,
                color: grey[500],
                display: "block",
                position: "relative",
                zIndex: "100",
                [theme.breakpoints.up("sm")]: {mt: 0.5},
              }}
            >
              <FormattedDate
                value={
                  articles[0].date_display
                    ? articles[0].date_display
                    : articles[0].published_at
                }
              />
            </Typography>
            <Typography
              variant="body2"
              sx={{
                position: "relative",
                zIndex: "100",
                "& a": {
                  transition: "all .2s ease-in-out",
                  color: theme.palette.secondary.main,
                  textDecoration: "none",
                  "&:visited": {
                    color: "#7E69EE",
                  },
                  "&:hover": {
                    color: "#7E69EE",
                    opacity: ".75",
                  },
                  "&:active": {
                    color: "#7E69EE",
                    opacity: "1",
                  },
                },
                "& img": {
                  maxWidth: "100%",
                },
              }}
            >
                <div dangerouslySetInnerHTML={{
                  __html: articles[0].html.replace(/href/ig, "target='_blank' rel='norefferer noopener' href ")
                }} />
            </Typography>
          </Grid>
          <Grid item xs={10}>
            <Divider />
          </Grid>
          {/* END NEWS */}
          <Grid item xs={10}>
            <Typography
              variant="h4"
              color="common.black"
              align="center"
              sx={{mb: 4}}
            >
              Weitere News
            </Typography>
            <NewsTeaser newsToExclude={articles[0]} />
          </Grid>
        </Grid>
      </ContentContainer>
    );
  }

  return <div>Loading...</div>;
};

export default News;
